import { Channel } from "@/lib/types";
import { getPlayer } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { AssignedPlayersRenderer } from "@/pages/player/shared/AssignedPlayersRenderer";
import { LoadingSmall } from "@/components/LoadingSmall";

interface Props {
  channel: Channel;
}

export const ChannelDetailAssignedPlayers = ({ channel }: Props) => {
  const activeFirm = useSelector(selectActiveFirm);

  const { data: playersResponse, isLoading } = useQuery({
    queryFn: () =>
      getPlayer(
        {
          numberOfObjectsPerPage: 999999,
          pageNumber: 1,
        },
        {
          Firm_Id: String(activeFirm?.firmGuid),
        }
      ),
    queryKey: ["channelPlayers", channel.id],
  });

  const players = (playersResponse?.data?.result || []).filter((player) => player.channelId === channel.id);

  if (isLoading) {
    return <LoadingSmall />;
  }

  return <AssignedPlayersRenderer players={players} />;
};
